
/* Aura Heaven — Mobile Enhancement JS */
(function () {
  'use strict';

  var PURPLE = '#7c3aed';
  var MESSAGES = [
    '🚚 Free Shipping on All US Orders',
    '⚡ 57,000+ Happy Customers',
    '↩️ 30-Day Hassle-Free Returns',
    '📦 Delivered in 7–14 Business Days',
    '🔒 100% Secure Checkout'
  ];

  /* ── Announcement Bar Cycling ── */
  function initAnnouncement() {
    var el = document.querySelector('.announcement-bar__message p, .announcement-bar__message span, .announcement-bar__message');
    if (!el) return;
    var i = 0;
    setInterval(function () {
      el.style.opacity = '0';
      setTimeout(function () {
        i = (i + 1) % MESSAGES.length;
        el.textContent = MESSAGES[i];
        el.style.opacity = '1';
      }, 300);
    }, 3600);
  }

  /* ── Sticky Add to Cart (mobile only) ── */
  function initStickyATC() {
    if (window.innerWidth > 749) return;
    var origBtn = document.querySelector('.product-form__submit');
    if (!origBtn) return;

    var priceEl = document.querySelector('.product__price .price-item--sale, .product__price .price-item--regular');
    var titleEl = document.querySelector('.product__title');
    var price   = priceEl ? priceEl.textContent.trim() : '';
    var name    = titleEl ? titleEl.textContent.trim().slice(0, 28) : '';

    var bar = document.createElement('div');
    bar.className = 'aura-sticky-atc';
    bar.innerHTML =
      '<div class="aura-sticky-atc__info">' +
        '<span class="aura-sticky-atc__name">' + name + '</span>' +
        '<span class="aura-sticky-atc__price">' + price + '</span>' +
      '</div>' +
      '<button class="aura-sticky-atc__btn" type="button">Add to Cart</button>';
    document.body.appendChild(bar);
    document.body.classList.add('aura-has-sticky');

    bar.querySelector('.aura-sticky-atc__btn').addEventListener('click', function () {
      origBtn.click();
      bar.querySelector('.aura-sticky-atc__btn').textContent = 'Adding…';
      setTimeout(function () {
        bar.querySelector('.aura-sticky-atc__btn').textContent = 'Add to Cart';
      }, 2000);
    });

    var obs = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      bar.classList.toggle('aura-visible', visible);
    }, { threshold: 0.1 });
    obs.observe(origBtn);
  }

  /* ── Back to Top ── */
  function initBackTop() {
    var btn = document.createElement('button');
    btn.className = 'aura-back-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '&#8593;';
    document.body.appendChild(btn);
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          btn.classList.toggle('aura-visible', window.scrollY > 500);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── Image lazy-load shimmer removal ── */
  function initImageLoad() {
    document.querySelectorAll('.card__media').forEach(function (el) {
      var img = el.querySelector('img');
      if (!img) return;
      if (img.complete) { el.classList.add('loaded'); return; }
      img.addEventListener('load', function () { el.classList.add('loaded'); });
    });
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }

  function run() {
    initAnnouncement();
    initStickyATC();
    initBackTop();
    initImageLoad();
  }
})();
